import {ADD_USER_PROFILE_TO_STORE, SET_AZURE_HEADER} from "./mutations";
import {UPDATE_USER_INFO} from "./actions";
import ApiService from "../../common/api.service";

const getDefaultState = () => {
    return {
        userProfile: {
            name: false,
            email: false,
            groups: [],
            firstName: false,
            azureAdObjectId: false,
        }
    }
};

const state = getDefaultState();

const getters = {
    userProfile(state) {
        return state.userProfile;
    },
};

const actions = {
    [UPDATE_USER_INFO]({commit}, data) {
        // console.log(data);
        commit(ADD_USER_PROFILE_TO_STORE, data.account);
        commit(SET_AZURE_HEADER, data);
    }
};

/* eslint no-param-reassign: ["error", { "props": false }] */
const mutations = {
    [ADD_USER_PROFILE_TO_STORE](state, data) {
        state.userProfile.name = data.name;
        state.userProfile.email = data.username;
        state.userProfile.groups = data.groups;
        state.userProfile.firstName = data.name.split()[0];
        state.userProfile.azureAdObjectId = data.localAccountId;
    },
    [SET_AZURE_HEADER](state, data) {
        // console.log(data);
        ApiService.setHeader(data);
    }
};

export default {
    state,
    getters,
    actions,
    mutations,
};
